// extracted by mini-css-extract-plugin
module.exports = {"bankBranches":"BankBranches__bankBranches--17GfO","option":"BankBranches__option--38KPy"};